import { loadArrayRandom } from "../../utils/random";

loadArrayRandom();

export const PAGAMENTO_DTO = [
  {
    "pgtoNr": "7162226518546028",
    "pgtoDtArrecadacao": "2022-09-22",
    "pgtoDtRegistro": "2022-09-23T17:24:48.000+00:00",
    "pgtoInTp": "0",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": 0,
    "pgtoBVlAlocadoRl": 0,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 374.98,
    "pgtoBVl1": 371.36,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 104,
    "pgtoAgenCd": 739,
    "codigoBancoCPS": "104",
    "codigoAgenciaCPS": "0739",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 374.98,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "99",
    "pgtoBInPassivo": "N",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2022-09-23T17:24:48.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "05201",
    "pgtoEstbPjNr": null,
    "pgtoEstbNr": null,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20220920,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": 36726865,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "2022-09-23",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20220801,
    "pgtoMndpCd": null,
    "pgtoBVl2": 3.62,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 57,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "7162226518546028",
    "pgtoDtLimitePgtoDeb": "2022-09-23",
    "pgtoDtRecepRegEmAg": "2022-09-22T15:40:00",
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": "6E6JG4Q0qpTkviOn4ZFeEEmgOyE00m35MsA",
    "pgtoInCondSitReg": 1,
    "pgtoUaDtPgto": 520100,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": "2022-09-22T15:40:00",
    "pgtoInOrigemAr": 1,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": 1,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 7,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-EMISSÃO DE DOCUMENTO"
    },
    "pgtoSearTprCd": 7,
    "segmentoProcedencia": {
      "codigo": 16,
      "descricao": "PUC - ESOCIAL"
    },
    "pgtoSearTspCd": 16,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": {
      "codigo": 1,
      "descricao": "DINHEIRO"
    },
    "pgtoTifpCd": 1,
    "receita01": {
      "codigo": 1410,
      "descricao": "DCTF-Web - Pagamento Unificado",
      "nomeEditado": "DCTF-Web - Pagamento Unificado",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 1410,
    "receita02": {
      "codigo": 1411,
      "descricao": "Multa - DCTF-Web - Pagamento Unificado",
      "nomeEditado": "Multa - DCTF-Web - Pagamento Unificado",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd2": 1411,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": {
      "codigo": 12,
      "descricao": "Programa Gerador do DCTFWeb"
    },
    "pgtoTsgiCd": 12,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "pgtoTpsiCd": 17,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": {
      "id": 3247,
      "nome": "TOBIAS BARRETO",
      "ufSg": "SE",
      "estado": {
        "id": "SE",
        "nome": "SERGIPE",
        "version": null
      },
      "version": null
    },
    "pgtoBCdMunDomContrib": 3247,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      1.24
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": "073952120685732",
    "codigoBarras": "85800000003749803852226607162226518546028963",
    "pessoaFisicaDto": {
      "codigo": 3672686557,
      "nome": "TRFOORZM XZILORMV YZGRHGZ NZIGRMH"
    },
    "pessoaJuridicaDto": null,
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": true,
    "documentoNumerado": true,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": true,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "7162228054009328",
    "pgtoDtArrecadacao": "2022-10-07",
    "pgtoDtRegistro": "2022-10-10T20:31:34.000+00:00",
    "pgtoInTp": "0",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": 0,
    "pgtoBVlAlocadoRl": 0,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 406.02,
    "pgtoBVl1": 406.02,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 104,
    "pgtoAgenCd": 739,
    "codigoBancoCPS": "104",
    "codigoAgenciaCPS": "0739",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 406.02,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "99",
    "pgtoBInPassivo": "N",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2022-10-10T20:31:34.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "05201",
    "pgtoEstbPjNr": null,
    "pgtoEstbNr": null,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20221020,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": 36726865,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "2022-10-10",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20220901,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 57,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "7162228054009328",
    "pgtoDtLimitePgtoDeb": "2022-10-20",
    "pgtoDtRecepRegEmAg": "2022-10-07T08:16:33",
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": "DoGin11z6VxUxTx170L2IlKq1e7k73C8D2D",
    "pgtoInCondSitReg": 1,
    "pgtoUaDtPgto": 520100,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": "2022-10-07T08:16:33",
    "pgtoInOrigemAr": 1,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": 1,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 7,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-EMISSÃO DE DOCUMENTO"
    },
    "pgtoSearTprCd": 7,
    "segmentoProcedencia": {
      "codigo": 16,
      "descricao": "PUC - ESOCIAL"
    },
    "pgtoSearTspCd": 16,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": {
      "codigo": 1,
      "descricao": "DINHEIRO"
    },
    "pgtoTifpCd": 1,
    "receita01": {
      "codigo": 1410,
      "descricao": "DCTF-Web - Pagamento Unificado",
      "nomeEditado": "DCTF-Web - Pagamento Unificado",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 1410,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": {
      "codigo": 12,
      "descricao": "Programa Gerador do DCTFWeb"
    },
    "pgtoTsgiCd": 12,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "pgtoTpsiCd": 17,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": {
      "id": 3247,
      "nome": "TOBIAS BARRETO",
      "ufSg": "SE",
      "estado": {
        "id": "SE",
        "nome": "SERGIPE",
        "version": null
      },
      "version": null
    },
    "pgtoBCdMunDomContrib": 3247,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      0
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": "073952521215255",
    "codigoBarras": "85830000004060203852229307162228054009328406",
    "pessoaFisicaDto": {
      "codigo": 3672686557,
      "nome": "TRFOORZM XZILORMV YZGRHGZ NZIGRMH"
    },
    "pessoaJuridicaDto": null,
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": true,
    "documentoNumerado": true,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": true,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "40926562",
    "pgtoDtArrecadacao": "1993-01-04",
    "pgtoDtRegistro": "2006-08-26T03:37:40.000+00:00",
    "pgtoInTp": "6",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 13970927,
    "pgtoBVl1": 13970927,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 3216,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "3380",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 13970927,
    "valorCancelado": null,
    "pgtoBInInteresse": "16",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "1993-01-11T02:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "01280",
    "pgtoEstbPjNr": 1646611,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 19930104,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": 0,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": 110,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "1993-01-11",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": null,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 74,
    "pgtoBDtRegistroGporte": "1993-01-11T02:00:00.000+00:00",
    "pgtoNrIdAr": null,
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": null,
    "pgtoBVlDjeSdnl": null,
    "pgtoBVlDjeSutd": null,
    "pgtoBVlDjeSdtd": null,
    "pgtoBVlDjeVtdc": null,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": null,
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": null,
    "procedencia": null,
    "pgtoSearTprCd": null,
    "segmentoProcedencia": null,
    "pgtoSearTspCd": null,
    "indicadorAutomacao": null,
    "pgtoSearTaudCd": null,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 3885,
      "descricao": "PIS - Receita Operacional",
      "nomeEditado": "PIS - Receita operacional",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 3885,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 6,
      "descricao": "DARF AZUL",
      "nomeAbreviado": "DARF AZUL"
    },
    "pgtoSearTdaCd": null,
    "natureza": null,
    "pgtoTnrCd": null,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 16,
      "descricao": "PJ GRANDE PORTE"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 1646611000174,
      "nome": "CONTRIBUINTE  1646611",
      "estbBInAcompEspecial": "N",
      "estbBInAcompDiferen": "N"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "40926572",
    "pgtoDtArrecadacao": "1993-01-04",
    "pgtoDtRegistro": "2006-08-26T03:37:40.000+00:00",
    "pgtoInTp": "6",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 42987467.44,
    "pgtoBVl1": 42987467.44,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 3216,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "3380",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 42987467.44,
    "valorCancelado": null,
    "pgtoBInInteresse": "16",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "1993-01-11T02:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "01280",
    "pgtoEstbPjNr": 1646611,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 19930104,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": 0,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": 111,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "1993-01-11",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": null,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 74,
    "pgtoBDtRegistroGporte": "1993-01-11T02:00:00.000+00:00",
    "pgtoNrIdAr": null,
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": null,
    "pgtoBVlDjeSdnl": null,
    "pgtoBVlDjeSutd": null,
    "pgtoBVlDjeSdtd": null,
    "pgtoBVlDjeVtdc": null,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": null,
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": null,
    "procedencia": null,
    "pgtoSearTprCd": null,
    "segmentoProcedencia": null,
    "pgtoSearTspCd": null,
    "indicadorAutomacao": null,
    "pgtoSearTaudCd": null,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 2172,
      "descricao": "Cofins - Contribuição para Financiamento Seguridade Social",
      "nomeEditado": "COFINS - Contribuição para financiamento da segurid. social",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 2172,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 6,
      "descricao": "DARF AZUL",
      "nomeAbreviado": "DARF AZUL"
    },
    "pgtoSearTdaCd": null,
    "natureza": null,
    "pgtoTnrCd": null,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 16,
      "descricao": "PJ GRANDE PORTE"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 1646611000174,
      "nome": "CONTRIBUINTE  1646611",
      "estbBInAcompEspecial": "N",
      "estbBInAcompDiferen": "N"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "3548240904",
    "pgtoDtArrecadacao": "2020-03-05",
    "pgtoDtRegistro": "2020-03-10T21:43:34.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "S",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 25,
    "pgtoBVl1": 25,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 237,
    "pgtoAgenCd": 123,
    "codigoBancoCPS": "237",
    "codigoAgenciaCPS": "0249",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "09",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2020-03-06T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "00001",
    "pgtoEstbPjNr": null,
    "pgtoEstbNr": null,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20200406,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": "82144443",
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2020-03-06",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20191001,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": "000000000000",
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "E",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": null,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10123707690001101",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 5300,
      "descricao": "Multa Atraso Entrega Declaração ITR",
      "nomeEditado": "Multa por atraso na entrega da DITR",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 5300,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 9,
      "descricao": "OUTROS INTERESSES"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": null,
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": "N",
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "3548302824",
    "pgtoDtArrecadacao": "2020-03-05",
    "pgtoDtRegistro": "2020-03-10T21:43:49.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "S",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 15.07,
    "pgtoBVl1": 15.07,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 237,
    "pgtoAgenCd": 1492,
    "codigoBancoCPS": "237",
    "codigoAgenciaCPS": "1203",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "09",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2020-03-06T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "00001",
    "pgtoEstbPjNr": null,
    "pgtoEstbNr": null,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20200325,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2020-03-06",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20200229,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": "000000000000",
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "E",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": null,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10123707690007293",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 8301,
      "descricao": "PIS - Folha de Pagamento",
      "nomeEditado": "PIS - Folha de pagamento",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 8301,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 9,
      "descricao": "OUTROS INTERESSES"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": null,
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": "N",
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "718074105",
    "pgtoDtArrecadacao": "2023-07-12",
    "pgtoDtRegistro": "2025-05-27T20:22:55.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 2,
      "descricao": "ALTERADO"
    },
    "pgtoSituCd": 2,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 630.8,
    "pgtoBVl1": 544.13,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 47,
    "pgtoAgenCd": 1,
    "codigoBancoCPS": "",
    "codigoAgenciaCPS": "",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "01",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2025-05-27T20:22:55.000+00:00",
    "pgtoBInHistorico": "S",
    "pgtoUa": "05201",
    "pgtoEstbPjNr": null,
    "pgtoEstbNr": null,
    "pgtoOepgCd": 2,
    "origemErro": {
      "codigo": 2,
      "descricao": "NÃO BANCO"
    },
    "pgtoDtVencimento": 20230630,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": "88888888888888888",
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": 36726865,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2023-07-13",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20230530,
    "pgtoMndpCd": null,
    "pgtoBVl2": 75.41,
    "pgtoBVl3": 11.26,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": 818000,
    "pgtoBIpTerminal": "172.24.54.119",
    "pgtoBNrTerminal": "SUITERFB",
    "pgtoBPfNrAtualiza": 988643357,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "X",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": "N",
    "pgtoNrDvContrib": 57,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10104706558000023",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 1,
      "descricao": "GUICHÊ DE CAIXA"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 1,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 211,
      "descricao": "IRPF - Declaração de Ajuste Anual, Declaração de Saída Definitiva do País e Declaração Final de Espólio",
      "nomeEditado": "IRPF - Declaração de ajuste anual, saída do país e espólio",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 211,
    "receita02": {
      "codigo": 3244,
      "descricao": "Multa - IRPF",
      "nomeEditado": "Multa - IRPF",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd2": 3244,
    "receita03": {
      "codigo": 641,
      "descricao": "Juros IRPF",
      "nomeEditado": "Juros - IRPF",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd3": 641,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": "2024-05-10T14:58:29.000+00:00",
    "pgtoBSituDt": "2024-05-10T14:58:29.000+00:00",
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 1,
      "descricao": "CONTACORPF"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": {
      "codigo": 3672686557,
      "nome": "TRFOORZM XZILORMV YZGRHGZ NZIGRMH"
    },
    "pessoaJuridicaDto": null,
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "7012432567561320",
    "pgtoDtArrecadacao": "2024-11-20",
    "pgtoDtRegistro": "2024-11-20T08:04:54.000+00:00",
    "pgtoInTp": "0",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": 0,
    "pgtoBVlAlocadoRl": 0,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 1223.31,
    "pgtoBVl1": 1223.31,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 745,
    "pgtoAgenCd": 1,
    "codigoBancoCPS": "745",
    "codigoAgenciaCPS": "1234",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 1223.31,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "99",
    "pgtoBInPassivo": "N",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2024-11-20T08:07:26.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "07176",
    "pgtoEstbPjNr": 55555,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20241121,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": "24BR000035158450001",
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "2024-11-20",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20241121,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 30,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "7012432567561320",
    "pgtoDtLimitePgtoDeb": "2024-12-01",
    "pgtoDtRecepRegEmAg": "2024-11-20T05:04:53",
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": 1,
    "pgtoUaDtPgto": 717600,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": "2024-11-20T05:04:53",
    "pgtoInOrigemAr": 1,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": 1,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 21,
      "descricao": "DÉBITO EM CONTA CORRENTE ONLINE PRÉ-AUTORIZADO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 21,
    "procedencia": {
      "codigo": 7,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-EMISSÃO DE DOCUMENTO"
    },
    "pgtoSearTprCd": 7,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": {
      "codigo": 5,
      "descricao": "CARTÃO/MULTIBANCO"
    },
    "pgtoTifpCd": 5,
    "receita01": {
      "codigo": 4444,
      "descricao": "Pagamento Unificado",
      "nomeEditado": "Pagamento Unificado",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 4444,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": {
      "codigo": 33,
      "descricao": "PROGRAMA GERADOR PCCE"
    },
    "pgtoTsgiCd": 33,
    "sistemaInteresse": {
      "codigo": 42,
      "descricao": "PCCE"
    },
    "pgtoTpsiCd": 42,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": {
      "id": 6001,
      "nome": "RIO DE JANEIRO",
      "ufSg": "RJ",
      "estado": {
        "id": "RJ",
        "nome": "RIO DE JANEIRO",
        "version": null
      },
      "version": null
    },
    "pgtoBCdMunDomContrib": 6001,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      1223.31
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": "11939845113206375478832",
    "codigoBarras": "85810000012233103852433607012432567561320254",
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 55555000130,
      "nome": "CONTRIBUINTE  55555",
      "estbBInAcompEspecial": "N",
      "estbBInAcompDiferen": "N"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": "S",
    "pago": true,
    "documentoNumerado": true,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": true,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "7012432567561338",
    "pgtoDtArrecadacao": "2024-11-20",
    "pgtoDtRegistro": "2024-11-20T08:05:59.000+00:00",
    "pgtoInTp": "0",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": 0,
    "pgtoBVlAlocadoRl": 0,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 2114.21,
    "pgtoBVl1": 2114.21,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 745,
    "pgtoAgenCd": 1,
    "codigoBancoCPS": "745",
    "codigoAgenciaCPS": "1234",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 2114.21,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "99",
    "pgtoBInPassivo": "N",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2024-11-20T08:53:30.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "07176",
    "pgtoEstbPjNr": 55555,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20241121,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": "24BR000035159180001",
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "2024-11-20",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20241121,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 30,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "7012432567561338",
    "pgtoDtLimitePgtoDeb": "2024-12-01",
    "pgtoDtRecepRegEmAg": "2024-11-20T05:05:59",
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": 1,
    "pgtoUaDtPgto": 717600,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": "2024-11-20T05:05:59",
    "pgtoInOrigemAr": 1,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": 1,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 21,
      "descricao": "DÉBITO EM CONTA CORRENTE ONLINE PRÉ-AUTORIZADO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 21,
    "procedencia": {
      "codigo": 7,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-EMISSÃO DE DOCUMENTO"
    },
    "pgtoSearTprCd": 7,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": {
      "codigo": 5,
      "descricao": "CARTÃO/MULTIBANCO"
    },
    "pgtoTifpCd": 5,
    "receita01": {
      "codigo": 4444,
      "descricao": "Pagamento Unificado",
      "nomeEditado": "Pagamento Unificado",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 4444,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": {
      "codigo": 33,
      "descricao": "PROGRAMA GERADOR PCCE"
    },
    "pgtoTsgiCd": 33,
    "sistemaInteresse": {
      "codigo": 42,
      "descricao": "PCCE"
    },
    "pgtoTpsiCd": 42,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": {
      "id": 6001,
      "nome": "RIO DE JANEIRO",
      "ufSg": "RJ",
      "estado": {
        "id": "RJ",
        "nome": "RIO DE JANEIRO",
        "version": null
      },
      "version": null
    },
    "pgtoBCdMunDomContrib": 6001,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      2114.21
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": "92235868614750399984821",
    "codigoBarras": "85860000021142103852433607012432567561338001",
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 55555000130,
      "nome": "CONTRIBUINTE  55555",
      "estbBInAcompEspecial": "N",
      "estbBInAcompDiferen": "N"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": "S",
    "pago": true,
    "documentoNumerado": true,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": true,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "7082400807280609",
    "pgtoDtArrecadacao": "2024-11-21",
    "pgtoDtRegistro": "2024-11-23T04:19:02.000+00:00",
    "pgtoInTp": "0",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": 0,
    "pgtoBVlAlocadoRl": 0,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 71.6,
    "pgtoBVl1": 71.6,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 2504,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "3331",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 71.6,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "99",
    "pgtoBInPassivo": "N",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2024-11-23T04:19:02.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "04301",
    "pgtoEstbPjNr": 50489130,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20241121,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "2024-11-22",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20241001,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 8,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "7082400807280609",
    "pgtoDtLimitePgtoDeb": "2024-11-21",
    "pgtoDtRecepRegEmAg": "2024-01-08T11:17:31",
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": "nxHMEa44a63s5Vzvl6c7B8PF0a",
    "pgtoInCondSitReg": 1,
    "pgtoUaDtPgto": 430108,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": "2024-01-08T11:17:31",
    "pgtoInOrigemAr": 1,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": 1,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 7,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-EMISSÃO DE DOCUMENTO"
    },
    "pgtoSearTprCd": 7,
    "segmentoProcedencia": {
      "codigo": 8,
      "descricao": "MICROEMPREENDEDOR INDIVIDUAL"
    },
    "pgtoSearTspCd": 8,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": {
      "codigo": 1,
      "descricao": "DINHEIRO"
    },
    "pgtoTifpCd": 1,
    "receita01": {
      "codigo": 55,
      "descricao": "Simples Nacional - MEI",
      "nomeEditado": "Simples Nacional - MEI",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 55,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 9,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DO SIMPLES NACIONAL",
      "nomeAbreviado": "DAS"
    },
    "pgtoSearTdaCd": 9,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": {
      "codigo": 15,
      "descricao": "PROGRAMA GERADOR DO DAS-MEI"
    },
    "pgtoTsgiCd": 15,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "pgtoTpsiCd": 17,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": {
      "id": 1981,
      "nome": "CAMPINA GRANDE",
      "ufSg": "PB",
      "estado": {
        "id": "PB",
        "nome": "PARAÍBA",
        "version": null
      },
      "version": null
    },
    "pgtoBCdMunDomContrib": 1981,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      71.6
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": "740A5795471B01DF",
    "codigoBarras": "85830000000716003282432607082400807280609109",
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 50489130000108,
      "nome": "CONTRIBUINTE  50489130",
      "estbBInAcompEspecial": null,
      "estbBInAcompDiferen": null
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": true,
    "documentoNumerado": true,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": true
  },
  {
    "pgtoNr": "7082401257860282",
    "pgtoDtArrecadacao": "2024-11-21",
    "pgtoDtRegistro": "2024-11-23T11:08:24.000+00:00",
    "pgtoInTp": "0",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": 0,
    "pgtoBVlAlocadoRl": 0,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 76.6,
    "pgtoBVl1": 76.6,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 8,
    "pgtoAgenCd": 0,
    "codigoBancoCPS": "008",
    "codigoAgenciaCPS": "3615",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 76.6,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "99",
    "pgtoBInPassivo": "N",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2024-11-23T11:08:24.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "08103",
    "pgtoEstbPjNr": 32274785,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20241121,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "2024-11-22",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20241001,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 87,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "7082401257860282",
    "pgtoDtLimitePgtoDeb": "2024-11-21",
    "pgtoDtRecepRegEmAg": "2024-01-12T19:38:22",
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": "xiQggL4axQDsYwdHsEjgxAaOtC",
    "pgtoInCondSitReg": 1,
    "pgtoUaDtPgto": 810306,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": "2024-01-12T19:38:22",
    "pgtoInOrigemAr": 1,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": 1,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 7,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-EMISSÃO DE DOCUMENTO"
    },
    "pgtoSearTprCd": 7,
    "segmentoProcedencia": {
      "codigo": 8,
      "descricao": "MICROEMPREENDEDOR INDIVIDUAL"
    },
    "pgtoSearTspCd": 8,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": {
      "codigo": 1,
      "descricao": "DINHEIRO"
    },
    "pgtoTifpCd": 1,
    "receita01": {
      "codigo": 55,
      "descricao": "Simples Nacional - MEI",
      "nomeEditado": "Simples Nacional - MEI",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 55,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 9,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DO SIMPLES NACIONAL",
      "nomeAbreviado": "DAS"
    },
    "pgtoSearTdaCd": 9,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": {
      "codigo": 15,
      "descricao": "PROGRAMA GERADOR DO DAS-MEI"
    },
    "pgtoTsgiCd": 15,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "pgtoTpsiCd": 17,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": {
      "id": 6189,
      "nome": "AVARÉ",
      "ufSg": "SP",
      "estado": {
        "id": "SP",
        "nome": "SÃO PAULO",
        "version": null
      },
      "version": null
    },
    "pgtoBCdMunDomContrib": 6189,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      0
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": "MBB35107BF245A0268287E0",
    "codigoBarras": "85870000000766003282432607082401257860282013",
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 32274785000187,
      "nome": "CONTRIBUINTE  32274785",
      "estbBInAcompEspecial": null,
      "estbBInAcompDiferen": null
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": true,
    "documentoNumerado": true,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": true
  },
  {
    "pgtoNr": "1381959695",
    "pgtoDtArrecadacao": "2024-11-21",
    "pgtoDtRegistro": "2024-11-23T05:00:40.000+00:00",
    "pgtoInTp": "7",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 29877.61,
    "pgtoBVl1": 29877.61,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 104,
    "pgtoAgenCd": 265,
    "codigoBancoCPS": "104",
    "codigoAgenciaCPS": "0265",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 29877.61,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "21",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2024-11-22T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "07185",
    "pgtoEstbPjNr": 73042962,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20241125,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": "50231059420214036100",
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2024-11-22",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20241031,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "X",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": 26563500115565,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 87,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10910426022000085",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 29877.61,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 1,
      "descricao": "GUICHÊ DE CAIXA"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 1,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 9,
      "descricao": "CONTROLE DE DJE"
    },
    "pgtoSearTspCd": 9,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 7460,
      "descricao": "PIS - Depósito Judicial",
      "nomeEditado": "PIS - Depósito judicial",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 7460,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 7,
      "descricao": "DOCUMENTO PARA DEPÓSITO JUDICIAL E EXTRA JUDICIAL",
      "nomeAbreviado": "DJE"
    },
    "pgtoSearTdaCd": 7,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 21,
      "descricao": "SIEF PROCESSOS"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      0
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 73042962000187,
      "nome": "CONTRIBUINTE  73042962",
      "estbBInAcompEspecial": "S",
      "estbBInAcompDiferen": "S"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": true,
    "das": false
  },
  {
    "pgtoNr": "1381959705",
    "pgtoDtArrecadacao": "2024-11-21",
    "pgtoDtRegistro": "2024-11-23T05:00:40.000+00:00",
    "pgtoInTp": "7",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 137618.1,
    "pgtoBVl1": 137618.1,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 104,
    "pgtoAgenCd": 265,
    "codigoBancoCPS": "104",
    "codigoAgenciaCPS": "0265",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 137618.1,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "21",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2024-11-22T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "07185",
    "pgtoEstbPjNr": 73042962,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20241125,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": "50231059420214036100",
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2024-11-22",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20241031,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "X",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": 26563500115564,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 87,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10910426022000086",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 137618.1,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 1,
      "descricao": "GUICHÊ DE CAIXA"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 1,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 9,
      "descricao": "CONTROLE DE DJE"
    },
    "pgtoSearTspCd": 9,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 7498,
      "descricao": "Cofins - Depósito Judicial",
      "nomeEditado": "COFINS - Depósito judicial",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 7498,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 7,
      "descricao": "DOCUMENTO PARA DEPÓSITO JUDICIAL E EXTRA JUDICIAL",
      "nomeAbreviado": "DJE"
    },
    "pgtoSearTdaCd": 7,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 21,
      "descricao": "SIEF PROCESSOS"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      0
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 73042962000187,
      "nome": "CONTRIBUINTE  73042962",
      "estbBInAcompEspecial": "S",
      "estbBInAcompDiferen": "S"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": true,
    "das": false
  },
  {
    "pgtoNr": "7012432567562210",
    "pgtoDtArrecadacao": "2024-12-01",
    "pgtoDtRegistro": "2024-11-20T08:14:10.000+00:00",
    "pgtoInTp": "0",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": 0,
    "pgtoBVlAlocadoRl": 0,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 1223.31,
    "pgtoBVl1": 1223.31,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": null,
    "pgtoAgenCd": null,
    "codigoBancoCPS": "",
    "codigoAgenciaCPS": "",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 1223.31,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "99",
    "pgtoBInPassivo": "N",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2024-11-20T08:14:10.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "07176",
    "pgtoEstbPjNr": 55555,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20241121,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": "24BR000035168840001",
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": null,
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20241121,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 30,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "7012432567562210",
    "pgtoDtLimitePgtoDeb": "2024-12-01",
    "pgtoDtRecepRegEmAg": "2024-11-20T05:14:10",
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": 2,
    "pgtoUaDtPgto": 717600,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": "2024-11-20T05:14:10",
    "pgtoInOrigemAr": 1,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": 1,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": null,
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": null,
    "procedencia": {
      "codigo": 7,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-EMISSÃO DE DOCUMENTO"
    },
    "pgtoSearTprCd": 7,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 4444,
      "descricao": "Pagamento Unificado",
      "nomeEditado": "Pagamento Unificado",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 4444,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": {
      "codigo": 33,
      "descricao": "PROGRAMA GERADOR PCCE"
    },
    "pgtoTsgiCd": 33,
    "sistemaInteresse": {
      "codigo": 42,
      "descricao": "PCCE"
    },
    "pgtoTpsiCd": 42,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": {
      "id": 6001,
      "nome": "RIO DE JANEIRO",
      "ufSg": "RJ",
      "estado": {
        "id": "RJ",
        "nome": "RIO DE JANEIRO",
        "version": null
      },
      "version": null
    },
    "pgtoBCdMunDomContrib": 6001,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      1223.31
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": "85810000012233103852433607012432567562210444",
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 55555000130,
      "nome": "CONTRIBUINTE  55555",
      "estbBInAcompEspecial": "N",
      "estbBInAcompDiferen": "N"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": "S",
    "pago": false,
    "documentoNumerado": true,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": true,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "7012432667562557",
    "pgtoDtArrecadacao": "2024-12-02",
    "pgtoDtRegistro": "2024-11-21T08:07:10.000+00:00",
    "pgtoInTp": "0",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": 0,
    "pgtoBVlAlocadoRl": 0,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 1223.31,
    "pgtoBVl1": 1223.31,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": null,
    "pgtoAgenCd": null,
    "codigoBancoCPS": "",
    "codigoAgenciaCPS": "",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 1223.31,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "99",
    "pgtoBInPassivo": "N",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2024-11-21T08:07:10.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "07176",
    "pgtoEstbPjNr": 55555,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20241122,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": "24BR000035174140001",
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": null,
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20241122,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 30,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "7012432667562557",
    "pgtoDtLimitePgtoDeb": "2024-12-02",
    "pgtoDtRecepRegEmAg": "2024-11-21T05:07:10",
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": 2,
    "pgtoUaDtPgto": 717600,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": "2024-11-21T05:07:10",
    "pgtoInOrigemAr": 1,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": 1,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": null,
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": null,
    "procedencia": {
      "codigo": 7,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-EMISSÃO DE DOCUMENTO"
    },
    "pgtoSearTprCd": 7,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 4444,
      "descricao": "Pagamento Unificado",
      "nomeEditado": "Pagamento Unificado",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 4444,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": {
      "codigo": 33,
      "descricao": "PROGRAMA GERADOR PCCE"
    },
    "pgtoTsgiCd": 33,
    "sistemaInteresse": {
      "codigo": 42,
      "descricao": "PCCE"
    },
    "pgtoTpsiCd": 42,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": {
      "id": 6001,
      "nome": "RIO DE JANEIRO",
      "ufSg": "RJ",
      "estado": {
        "id": "RJ",
        "nome": "RIO DE JANEIRO",
        "version": null
      },
      "version": null
    },
    "pgtoBCdMunDomContrib": 6001,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      1223.31
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": "85800000012233103852433707012432667562557578",
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 55555000130,
      "nome": "CONTRIBUINTE  55555",
      "estbBInAcompEspecial": "N",
      "estbBInAcompDiferen": "N"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": "S",
    "pago": false,
    "documentoNumerado": true,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": true,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "7082431713669910",
    "pgtoDtArrecadacao": "2024-11-21",
    "pgtoDtRegistro": "2024-11-12T16:52:48.000+00:00",
    "pgtoInTp": "0",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": 0,
    "pgtoBVlAlocadoRl": 0,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 75.6,
    "pgtoBVl1": 75.6,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": null,
    "pgtoAgenCd": null,
    "codigoBancoCPS": "",
    "codigoAgenciaCPS": "",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 75.6,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "99",
    "pgtoBInPassivo": "N",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2024-11-12T16:52:48.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "06101",
    "pgtoEstbPjNr": 29353550,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20241121,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": null,
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20241001,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 76,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "7082431713669910",
    "pgtoDtLimitePgtoDeb": "2024-11-21",
    "pgtoDtRecepRegEmAg": "2024-11-12T12:27:38",
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": "07082431713669910096604104",
    "pgtoInCondSitReg": 3,
    "pgtoUaDtPgto": 610100,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": "2024-11-12T12:27:38",
    "pgtoInOrigemAr": 1,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": 1,
    "pgtoTqrpCd": 1,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": null,
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": null,
    "procedencia": {
      "codigo": 7,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-EMISSÃO DE DOCUMENTO"
    },
    "pgtoSearTprCd": 7,
    "segmentoProcedencia": {
      "codigo": 8,
      "descricao": "MICROEMPREENDEDOR INDIVIDUAL"
    },
    "pgtoSearTspCd": 8,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 55,
      "descricao": "Simples Nacional - MEI",
      "nomeEditado": "Simples Nacional - MEI",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 55,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 9,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DO SIMPLES NACIONAL",
      "nomeAbreviado": "DAS"
    },
    "pgtoSearTdaCd": 9,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": {
      "codigo": 15,
      "descricao": "PROGRAMA GERADOR DO DAS-MEI"
    },
    "pgtoTsgiCd": 15,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "pgtoTpsiCd": 17,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": {
      "id": 4123,
      "nome": "BELO HORIZONTE",
      "ufSg": "MG",
      "estado": {
        "id": "MG",
        "nome": "MINAS GERAIS",
        "version": null
      },
      "version": null
    },
    "pgtoBCdMunDomContrib": 4123,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      75.6
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": "85840000000756003282432607082431713669910677",
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 29353550000176,
      "nome": "CONTRIBUINTE  29353550",
      "estbBInAcompEspecial": null,
      "estbBInAcompDiferen": null
    },
    "agendadoPara": "21/11/2024 - Débito não encontrado",
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": true,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": true,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": true
  },
  {
    "pgtoNr": "7082431720997560",
    "pgtoDtArrecadacao": "2024-11-21",
    "pgtoDtRegistro": "2024-11-12T22:11:06.000+00:00",
    "pgtoInTp": "0",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": 0,
    "pgtoBVlAlocadoRl": 0,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 76.6,
    "pgtoBVl1": 76.6,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": null,
    "pgtoAgenCd": null,
    "codigoBancoCPS": "",
    "codigoAgenciaCPS": "",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 76.6,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "99",
    "pgtoBInPassivo": "N",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2024-11-12T22:11:06.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "08113",
    "pgtoEstbPjNr": 19318173,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20241121,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": null,
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20241001,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 80,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "7082431720997560",
    "pgtoDtLimitePgtoDeb": "2024-11-21",
    "pgtoDtRecepRegEmAg": "2024-11-12T15:13:24",
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": "07082431720997560095025614",
    "pgtoInCondSitReg": 3,
    "pgtoUaDtPgto": 811305,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": "2024-11-12T15:13:24",
    "pgtoInOrigemAr": 1,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": 1,
    "pgtoTqrpCd": 1,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": null,
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": null,
    "procedencia": {
      "codigo": 7,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-EMISSÃO DE DOCUMENTO"
    },
    "pgtoSearTprCd": 7,
    "segmentoProcedencia": {
      "codigo": 8,
      "descricao": "MICROEMPREENDEDOR INDIVIDUAL"
    },
    "pgtoSearTspCd": 8,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 55,
      "descricao": "Simples Nacional - MEI",
      "nomeEditado": "Simples Nacional - MEI",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 55,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 9,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DO SIMPLES NACIONAL",
      "nomeAbreviado": "DAS"
    },
    "pgtoSearTdaCd": 9,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": {
      "codigo": 15,
      "descricao": "PROGRAMA GERADOR DO DAS-MEI"
    },
    "pgtoTsgiCd": 15,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "pgtoTpsiCd": 17,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": {
      "id": 6545,
      "nome": "ITAPECERICA DA SERRA",
      "ufSg": "SP",
      "estado": {
        "id": "SP",
        "nome": "SÃO PAULO",
        "version": null
      },
      "version": null
    },
    "pgtoBCdMunDomContrib": 6545,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      76.6
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": "85890000000766003282432607082431720997560996",
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 19318173000180,
      "nome": "CONTRIBUINTE  19318173",
      "estbBInAcompEspecial": null,
      "estbBInAcompDiferen": null
    },
    "agendadoPara": "21/11/2024 - Débito não encontrado",
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": true,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": true,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": true
  },
  {
    "pgtoNr": "2328644674",
    "pgtoDtArrecadacao": "2010-04-19",
    "pgtoDtRegistro": "2019-01-23T12:09:36.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 2,
      "descricao": "ALTERADO"
    },
    "pgtoSituCd": 2,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 806.62,
    "pgtoBVl1": 806.62,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 1,
    "codigoBancoCPS": "",
    "codigoAgenciaCPS": "",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "09",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2019-01-23T12:09:35.000+00:00",
    "pgtoBInHistorico": "S",
    "pgtoUa": "08166",
    "pgtoEstbPjNr": 0,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": 2,
    "origemErro": {
      "codigo": 2,
      "descricao": "NÃO BANCO"
    },
    "pgtoDtVencimento": 20100419,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": "10010003210091465",
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2019-01-03",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20100419,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": 110100,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": "00023272",
    "pgtoBPfNrAtualiza": 49871076,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 91,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "50100101812000002",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 13,
      "descricao": "MENSAGERIA SPB"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 13,
    "procedencia": {
      "codigo": 5,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-PRESTAÇÃO DE CONTAS"
    },
    "pgtoSearTprCd": 5,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 4578,
      "descricao": "Encargos por Recolhimento fora do Prazo - Simples Nacional",
      "nomeEditado": "Encargos por Recolhimento fora do Prazo - Simples Nacional",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 4578,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": "2019-01-23T12:09:35.000+00:00",
    "pgtoBSituDt": "2019-01-23T12:05:13.000+00:00",
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 9,
      "descricao": "OUTROS INTERESSES"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 191,
      "nome": "CONTRIBUINTE  0",
      "estbBInAcompEspecial": "S",
      "estbBInAcompDiferen": "S"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": "N",
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "4026803803",
    "pgtoDtArrecadacao": "2015-01-30",
    "pgtoDtRegistro": "2015-02-03T07:20:02.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 88.13,
    "pgtoBVl1": 88.13,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 1,
    "codigoBancoCPS": "",
    "codigoAgenciaCPS": "",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "09",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2015-01-31T02:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "01280",
    "pgtoEstbPjNr": 0,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20150130,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2015-01-31",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20141219,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 91,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "50100101470000002",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 13,
      "descricao": "MENSAGERIA SPB"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 13,
    "procedencia": {
      "codigo": 5,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-PRESTAÇÃO DE CONTAS"
    },
    "pgtoSearTprCd": 5,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 4578,
      "descricao": "Encargos por Recolhimento fora do Prazo - Simples Nacional",
      "nomeEditado": "Encargos por Recolhimento fora do Prazo - Simples Nacional",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 4578,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 9,
      "descricao": "OUTROS INTERESSES"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 191,
      "nome": "CONTRIBUINTE  0",
      "estbBInAcompEspecial": "S",
      "estbBInAcompDiferen": "S"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": "N",
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "80401322",
    "pgtoDtArrecadacao": "1993-01-21",
    "pgtoDtRegistro": "2006-08-25T22:37:56.000+00:00",
    "pgtoInTp": "6",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 2500,
    "pgtoBVl1": 2500,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 2,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "0002",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "00",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "1993-01-26T02:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "07185",
    "pgtoEstbPjNr": 34019992,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 19930121,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": 0,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": 101,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "1993-01-26",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": null,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 10,
    "pgtoBDtRegistroGporte": "1993-01-26T02:00:00.000+00:00",
    "pgtoNrIdAr": null,
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": null,
    "pgtoBVlDjeSdnl": null,
    "pgtoBVlDjeSutd": null,
    "pgtoBVlDjeSdtd": null,
    "pgtoBVlDjeVtdc": null,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": null,
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": null,
    "procedencia": null,
    "pgtoSearTprCd": null,
    "segmentoProcedencia": null,
    "pgtoSearTspCd": null,
    "indicadorAutomacao": null,
    "pgtoSearTaudCd": null,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 1548,
      "descricao": "Taxa de Fiscalização de  Produtos Sob Controle  do Ministério do Exército",
      "nomeEditado": "Taxa de fiscalização produtos sob controle do Min. Exército",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 1548,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 6,
      "descricao": "DARF AZUL",
      "nomeAbreviado": "DARF AZUL"
    },
    "pgtoSearTdaCd": null,
    "natureza": null,
    "pgtoTnrCd": null,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 0,
      "descricao": "NAO ASSINALADO"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 34019992000110,
      "nome": "CONTRIBUINTE  34019992",
      "estbBInAcompEspecial": "S",
      "estbBInAcompDiferen": "S"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "81624152",
    "pgtoDtArrecadacao": "1993-02-19",
    "pgtoDtRegistro": "2006-08-25T15:07:31.000+00:00",
    "pgtoInTp": "6",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 2003.3,
    "pgtoBVl1": 2003.3,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 2,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "0002",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "00",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "1993-02-26T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "02181",
    "pgtoEstbPjNr": 4461836,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 19930219,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": 0,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": 172,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "1993-02-26",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": null,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 44,
    "pgtoBDtRegistroGporte": "1993-02-26T03:00:00.000+00:00",
    "pgtoNrIdAr": null,
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": null,
    "pgtoBVlDjeSdnl": null,
    "pgtoBVlDjeSutd": null,
    "pgtoBVlDjeSdtd": null,
    "pgtoBVlDjeVtdc": null,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": null,
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": null,
    "procedencia": null,
    "pgtoSearTprCd": null,
    "segmentoProcedencia": null,
    "pgtoSearTspCd": null,
    "indicadorAutomacao": null,
    "pgtoSearTaudCd": null,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 3607,
      "descricao": "Restituições - outras",
      "nomeEditado": "Restituições - Outras",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 3607,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 6,
      "descricao": "DARF AZUL",
      "nomeAbreviado": "DARF AZUL"
    },
    "pgtoSearTdaCd": null,
    "natureza": null,
    "pgtoTnrCd": null,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 0,
      "descricao": "NAO ASSINALADO"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 4461836000144,
      "nome": "CONTRIBUINTE  4461836",
      "estbBInAcompEspecial": "N",
      "estbBInAcompDiferen": "N"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "4402106163",
    "pgtoDtArrecadacao": "2015-05-29",
    "pgtoDtRegistro": "2015-06-03T00:29:30.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 104.93,
    "pgtoBVl1": 79.22,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 1,
    "codigoBancoCPS": "",
    "codigoAgenciaCPS": "",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "13",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2015-06-01T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "01280",
    "pgtoEstbPjNr": null,
    "pgtoEstbNr": null,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20150529,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": "10166402078201511",
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": 888986526,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2015-06-01",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 19800101,
    "pgtoMndpCd": null,
    "pgtoBVl2": 15.84,
    "pgtoBVl3": 9.87,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": "S",
    "pgtoInMeioColeta": "D",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 15,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "60300100107000018",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 14,
      "descricao": "DÉBITO AUTOMATICO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 14,
    "procedencia": {
      "codigo": 6,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-DÉBITO AUTOMÁTICO"
    },
    "pgtoSearTprCd": 6,
    "segmentoProcedencia": {
      "codigo": 3,
      "descricao": "PARCELAMENTO"
    },
    "pgtoSearTspCd": 3,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 211,
      "descricao": "IRPF - Declaração de Ajuste Anual, Declaração de Saída Definitiva do País e Declaração Final de Espólio",
      "nomeEditado": "IRPF - Declaração de ajuste anual, saída do país e espólio",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 211,
    "receita02": {
      "codigo": 3244,
      "descricao": "Multa - IRPF",
      "nomeEditado": "Multa - IRPF",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd2": 3244,
    "receita03": {
      "codigo": 641,
      "descricao": "Juros IRPF",
      "nomeEditado": "Juros - IRPF",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd3": 641,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 13,
      "descricao": "SIPADE"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": null,
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": "N",
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "4500157823",
    "pgtoDtArrecadacao": "2015-06-30",
    "pgtoDtRegistro": "2015-07-03T07:45:14.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 132.97,
    "pgtoBVl1": 93.5,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 1,
    "codigoBancoCPS": "",
    "codigoAgenciaCPS": "",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "13",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2015-07-01T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "03301",
    "pgtoEstbPjNr": null,
    "pgtoEstbNr": null,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20150630,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": "10384721459201521",
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": 361381933,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2015-07-01",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 19800101,
    "pgtoMndpCd": null,
    "pgtoBVl2": 18.7,
    "pgtoBVl3": 20.77,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": "S",
    "pgtoInMeioColeta": "D",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 34,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "60300100109000167",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 14,
      "descricao": "DÉBITO AUTOMATICO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 14,
    "procedencia": {
      "codigo": 6,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-DÉBITO AUTOMÁTICO"
    },
    "pgtoSearTprCd": 6,
    "segmentoProcedencia": {
      "codigo": 3,
      "descricao": "PARCELAMENTO"
    },
    "pgtoSearTspCd": 3,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 211,
      "descricao": "IRPF - Declaração de Ajuste Anual, Declaração de Saída Definitiva do País e Declaração Final de Espólio",
      "nomeEditado": "IRPF - Declaração de ajuste anual, saída do país e espólio",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 211,
    "receita02": {
      "codigo": 3244,
      "descricao": "Multa - IRPF",
      "nomeEditado": "Multa - IRPF",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd2": 3244,
    "receita03": {
      "codigo": 641,
      "descricao": "Juros IRPF",
      "nomeEditado": "Juros - IRPF",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd3": 641,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 13,
      "descricao": "SIPADE"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": null,
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": "N",
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "4048336713",
    "pgtoDtArrecadacao": "2015-02-02",
    "pgtoDtRegistro": "2015-02-04T08:15:59.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 36.66,
    "pgtoBVl1": 36.66,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 1,
    "codigoBancoCPS": "",
    "codigoAgenciaCPS": "",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "20",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2015-02-03T02:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "01280",
    "pgtoEstbPjNr": 0,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20150202,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2015-02-03",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20150129,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 91,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "50100101471000002",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 13,
      "descricao": "MENSAGERIA SPB"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 13,
    "procedencia": {
      "codigo": 5,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-PRESTAÇÃO DE CONTAS"
    },
    "pgtoSearTprCd": 5,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 4570,
      "descricao": "Encargos por Recolhimento fora do Prazo",
      "nomeEditado": "Encargos por recolhimento fora do prazo",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 4570,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 20,
      "descricao": "ANCORA"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 191,
      "nome": "CONTRIBUINTE  0",
      "estbBInAcompEspecial": "S",
      "estbBInAcompDiferen": "S"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": "N",
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "85986572",
    "pgtoDtArrecadacao": "1993-06-14",
    "pgtoDtRegistro": "2006-08-26T22:10:14.000+00:00",
    "pgtoInTp": "6",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "T",
    "pgtoVlTotal": 2728219.08,
    "pgtoBVl1": 2728219.08,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 2,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "0002",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "01",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "1993-06-17T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "10102",
    "pgtoEstbPjNr": null,
    "pgtoEstbNr": null,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 19930614,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": 0,
    "pgtoPfNr": 219057971,
    "pgtoBNrBdaSq": 127,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "1993-06-17",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": null,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 68,
    "pgtoBDtRegistroGporte": "1993-06-17T03:00:00.000+00:00",
    "pgtoNrIdAr": null,
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": null,
    "pgtoBVlDjeSdnl": null,
    "pgtoBVlDjeSutd": null,
    "pgtoBVlDjeSdtd": null,
    "pgtoBVlDjeVtdc": null,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": null,
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": null,
    "procedencia": null,
    "pgtoSearTprCd": null,
    "segmentoProcedencia": null,
    "pgtoSearTspCd": null,
    "indicadorAutomacao": null,
    "pgtoSearTaudCd": null,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 211,
      "descricao": "IRPF - Declaração de Ajuste Anual, Declaração de Saída Definitiva do País e Declaração Final de Espólio",
      "nomeEditado": "IRPF - Declaração de ajuste anual, saída do país e espólio",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 211,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 6,
      "descricao": "DARF AZUL",
      "nomeAbreviado": "DARF AZUL"
    },
    "pgtoSearTdaCd": null,
    "natureza": null,
    "pgtoTnrCd": null,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 1,
      "descricao": "CONTACORPF"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": null,
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "217412941",
    "pgtoDtArrecadacao": "1995-05-31",
    "pgtoDtRegistro": "2006-08-23T14:17:48.000+00:00",
    "pgtoInTp": "6",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "T",
    "pgtoVlTotal": 171.53,
    "pgtoBVl1": 171.53,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 2,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "0002",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "01",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "1995-06-05T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "10102",
    "pgtoEstbPjNr": null,
    "pgtoEstbNr": null,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 19950531,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": 102,
    "pgtoPfNr": 219057971,
    "pgtoBNrBdaSq": 137,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "1995-06-05",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": null,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 68,
    "pgtoBDtRegistroGporte": "1995-06-05T03:00:00.000+00:00",
    "pgtoNrIdAr": null,
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": null,
    "pgtoBVlDjeSdnl": null,
    "pgtoBVlDjeSutd": null,
    "pgtoBVlDjeSdtd": null,
    "pgtoBVlDjeVtdc": null,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": null,
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": null,
    "procedencia": null,
    "pgtoSearTprCd": null,
    "segmentoProcedencia": null,
    "pgtoSearTspCd": null,
    "indicadorAutomacao": null,
    "pgtoSearTaudCd": null,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 211,
      "descricao": "IRPF - Declaração de Ajuste Anual, Declaração de Saída Definitiva do País e Declaração Final de Espólio",
      "nomeEditado": "IRPF - Declaração de ajuste anual, saída do país e espólio",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 211,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 6,
      "descricao": "DARF AZUL",
      "nomeAbreviado": "DARF AZUL"
    },
    "pgtoSearTdaCd": null,
    "natureza": null,
    "pgtoTnrCd": null,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 1,
      "descricao": "CONTACORPF"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": null,
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "1036002065",
    "pgtoDtArrecadacao": "2024-01-22",
    "pgtoDtRegistro": "2025-05-29T23:10:51.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 2,
      "descricao": "ALTERADO"
    },
    "pgtoSituCd": 2,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 3568.67,
    "pgtoBVl1": 3568.67,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 13,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "0013",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "09",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2025-05-29T23:10:50.000+00:00",
    "pgtoBInHistorico": "S",
    "pgtoUa": "08166",
    "pgtoEstbPjNr": 12229753,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": 2,
    "origemErro": {
      "codigo": 2,
      "descricao": "NÃO BANCO"
    },
    "pgtoDtVencimento": 20240122,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": "21180093200951900",
    "pgtoProcNr": "10880412494201217",
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2024-01-23",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20231218,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": 818000,
    "pgtoBIpTerminal": "172.24.54.119",
    "pgtoBNrTerminal": "SUITERFB",
    "pgtoBPfNrAtualiza": 988643357,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "E",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": "N",
    "pgtoNrDvContrib": 91,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10100107829000511",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 6092,
      "descricao": "Contribuições Previdenciárias - Recolhimento Exclusivo pela Justiça do Trabalho",
      "nomeEditado": "Contribuição Previdenciária - Recolhimento Justiça Trabalho",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 6092,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": "2025-05-29T22:47:48.000+00:00",
    "pgtoBSituDt": "2025-05-29T22:47:48.000+00:00",
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 9,
      "descricao": "OUTROS INTERESSES"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 191,
      "nome": "CONTRIBUINTE  0",
      "estbBInAcompEspecial": "S",
      "estbBInAcompDiferen": "S"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "718074215",
    "pgtoDtArrecadacao": "2023-07-12",
    "pgtoDtRegistro": "2025-06-02T12:11:16.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 2,
      "descricao": "ALTERADO"
    },
    "pgtoSituCd": 2,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 573.34,
    "pgtoBVl1": 544.13,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 47,
    "pgtoAgenCd": 1,
    "codigoBancoCPS": "",
    "codigoAgenciaCPS": "",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "01",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2025-06-02T12:11:15.000+00:00",
    "pgtoBInHistorico": "S",
    "pgtoUa": "07182",
    "pgtoEstbPjNr": null,
    "pgtoEstbNr": null,
    "pgtoOepgCd": 2,
    "origemErro": {
      "codigo": 2,
      "descricao": "NÃO BANCO"
    },
    "pgtoDtVencimento": 20230630,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": "10880412494201217",
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": 36726865,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2023-07-13",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20221231,
    "pgtoMndpCd": null,
    "pgtoBVl2": 17.95,
    "pgtoBVl3": 11.26,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": 818000,
    "pgtoBIpTerminal": "172.20.138.179",
    "pgtoBNrTerminal": "SUITERFB",
    "pgtoBPfNrAtualiza": 988643357,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "X",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": "N",
    "pgtoNrDvContrib": 87,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10104706558000034",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 1,
      "descricao": "GUICHÊ DE CAIXA"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 1,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 211,
      "descricao": "IRPF - Declaração de Ajuste Anual, Declaração de Saída Definitiva do País e Declaração Final de Espólio",
      "nomeEditado": "IRPF - Declaração de ajuste anual, saída do país e espólio",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 211,
    "receita02": {
      "codigo": 3244,
      "descricao": "Multa - IRPF",
      "nomeEditado": "Multa - IRPF",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd2": 3244,
    "receita03": {
      "codigo": 641,
      "descricao": "Juros IRPF",
      "nomeEditado": "Juros - IRPF",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd3": 641,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": "2025-06-02T12:11:15.000+00:00",
    "pgtoBSituDt": "2025-06-02T12:11:15.000+00:00",
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 1,
      "descricao": "CONTACORPF"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": {
      "codigo": 78227585787,
      "nome": "NZIXVOL UVIMZMWVH NVMWVH"
    },
    "pessoaJuridicaDto": null,
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "3800091914",
    "pgtoDtArrecadacao": "2020-06-30",
    "pgtoDtRegistro": "2025-06-02T18:58:29.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 2,
      "descricao": "ALTERADO"
    },
    "pgtoSituCd": 2,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 828.19,
    "pgtoBVl1": 539.57,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 1451,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "1050",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "24",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2025-06-02T18:58:29.000+00:00",
    "pgtoBInHistorico": "S",
    "pgtoUa": "04401",
    "pgtoEstbPjNr": 12229753,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": 2,
    "origemErro": {
      "codigo": 2,
      "descricao": "NÃO BANCO"
    },
    "pgtoDtVencimento": 20200529,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": "88888888888888888",
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2020-07-01",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20200529,
    "pgtoMndpCd": null,
    "pgtoBVl2": 288.62,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": 818000,
    "pgtoBIpTerminal": "172.20.138.179",
    "pgtoBNrTerminal": "SUITERFB",
    "pgtoBPfNrAtualiza": 988643357,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "E",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": "N",
    "pgtoNrDvContrib": 52,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10100106830258087",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 4737,
      "descricao": "Lei nº 12.996, de 2014 - PGFN - Demais Débitos - Parcelamento",
      "nomeEditado": "Lei nº 12.996, de 2014 - PGFN - Demais Débitos -Parcelamento",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 4737,
    "receita02": {
      "codigo": 4737,
      "descricao": "Lei nº 12.996, de 2014 - PGFN - Demais Débitos - Parcelamento",
      "nomeEditado": "Lei nº 12.996, de 2014 - PGFN - Demais Débitos -Parcelamento",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd2": 4737,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": "2025-06-02T18:58:29.000+00:00",
    "pgtoBSituDt": "2025-06-02T18:58:29.000+00:00",
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 24,
      "descricao": "PAEX"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 12229753000152,
      "nome": "CONTRIBUINTE  12229753",
      "estbBInAcompEspecial": "N",
      "estbBInAcompDiferen": "S"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "800342715",
    "pgtoDtArrecadacao": "2023-08-31",
    "pgtoDtRegistro": "2025-06-02T17:43:41.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 2,
      "descricao": "ALTERADO"
    },
    "pgtoSituCd": 2,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 616.87,
    "pgtoBVl1": 544.13,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 104,
    "pgtoAgenCd": 739,
    "codigoBancoCPS": "104",
    "codigoAgenciaCPS": "0739",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "01",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2025-06-02T17:43:41.000+00:00",
    "pgtoBInHistorico": "S",
    "pgtoUa": "05201",
    "pgtoEstbPjNr": null,
    "pgtoEstbNr": null,
    "pgtoOepgCd": 2,
    "origemErro": {
      "codigo": 2,
      "descricao": "NÃO BANCO"
    },
    "pgtoDtVencimento": 20230731,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": "88888888888888888",
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": 36726865,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2023-09-01",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20221231,
    "pgtoMndpCd": null,
    "pgtoBVl2": 55.66,
    "pgtoBVl3": 17.08,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": 818000,
    "pgtoBIpTerminal": "172.20.138.179",
    "pgtoBNrTerminal": "SUITERFB",
    "pgtoBPfNrAtualiza": 988643357,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "E",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": "N",
    "pgtoNrDvContrib": 57,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10110420709007528",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 211,
      "descricao": "IRPF - Declaração de Ajuste Anual, Declaração de Saída Definitiva do País e Declaração Final de Espólio",
      "nomeEditado": "IRPF - Declaração de ajuste anual, saída do país e espólio",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 211,
    "receita02": {
      "codigo": 3244,
      "descricao": "Multa - IRPF",
      "nomeEditado": "Multa - IRPF",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd2": 3244,
    "receita03": {
      "codigo": 641,
      "descricao": "Juros IRPF",
      "nomeEditado": "Juros - IRPF",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd3": 641,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": "2025-06-02T17:43:41.000+00:00",
    "pgtoBSituDt": "2025-06-02T17:43:41.000+00:00",
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 1,
      "descricao": "CONTACORPF"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": {
      "codigo": 3672686557,
      "nome": "TRFOORZM XZILORMV YZGRHGZ NZIGRMH"
    },
    "pessoaJuridicaDto": null,
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "9012205400026256",
    "pgtoDtArrecadacao": "2022-02-18",
    "pgtoDtRegistro": "2023-05-17T13:44:29.000+00:00",
    "pgtoInTp": "0",
    "situacao": {
      "codigo": 7,
      "descricao": "BLOQUEADO PARCIAL"
    },
    "pgtoSituCd": 7,
    "pgtoBVlCompensacao": 0,
    "pgtoBVlAlocadoRl": 0,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 198.08,
    "pgtoBVl1": 198.08,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 104,
    "pgtoAgenCd": 626,
    "codigoBancoCPS": "104",
    "codigoAgenciaCPS": "0626",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 198.08,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "99",
    "pgtoBInPassivo": "N",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2023-05-17T13:44:17.000+00:00",
    "pgtoBInHistorico": "S",
    "pgtoUa": "04101",
    "pgtoEstbPjNr": 35739649,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20220218,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": "2216",
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "2022-02-21",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20220131,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": 22006,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": "SUITERFB",
    "pgtoBPfNrAtualiza": 770484157,
    "pgtoBVlRestituicao": 50.03,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 3,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "9012205400026256",
    "pgtoDtLimitePgtoDeb": "2022-02-18",
    "pgtoDtRecepRegEmAg": "2022-02-16T05:58:42",
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": "O3V7OwjetO0SrIU3iBLQgwAvuKWqlRY7SIC",
    "pgtoInCondSitReg": 1,
    "pgtoUaDtPgto": 410113,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": "2022-02-16T05:58:42",
    "pgtoInOrigemAr": 1,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": "7012204701709235",
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": 4,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 1,
      "descricao": "GUICHÊ DE CAIXA"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 1,
    "procedencia": {
      "codigo": 9,
      "descricao": "AMBIENTE DE PAGAMENTOS RFB - SIEFRDOC"
    },
    "pgtoSearTprCd": 9,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": {
      "codigo": 1,
      "descricao": "DINHEIRO"
    },
    "pgtoTifpCd": 1,
    "receita01": {
      "codigo": 1082,
      "descricao": "Contribuição previdenciária descontada de segurados empregados e avulsos e de trabalhadores rurais contratados por pequeno prazo.",
      "nomeEditado": "Contrib Previd Descontada de Segurados Empregados/Avulsos",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 1082,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": {
      "codigo": 8,
      "descricao": "PROGRAMA GERADOR DO SICALCWEB"
    },
    "pgtoTsgiCd": 8,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "pgtoTpsiCd": 17,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": {
      "id": 2627,
      "nome": "VITÓRIA DE SANTO ANTÃO",
      "ufSg": "PE",
      "estado": {
        "id": "PE",
        "nome": "PERNAMBUCO",
        "version": null
      },
      "version": null
    },
    "pgtoBCdMunDomContrib": 2627,
    "pgtoDovrNrSq": 6350764,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      48.05
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": "RFE20220221130237422046",
    "codigoBarras": "85880000001980803852204909012205400026256006",
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 35739649000103,
      "nome": "CONTRIBUINTE  35739649",
      "estbBInAcompEspecial": null,
      "estbBInAcompDiferen": null
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": true,
    "documentoNumerado": true,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": true,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "7012215095467217",
    "pgtoDtArrecadacao": "2022-05-30",
    "pgtoDtRegistro": "2025-06-02T21:53:44.000+00:00",
    "pgtoInTp": "0",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": 0,
    "pgtoBVlAlocadoRl": 0,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 24974.01,
    "pgtoBVl1": 24974.01,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 1098,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "2809",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 24974.01,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "99",
    "pgtoBInPassivo": "N",
    "pgtoBInAtualizacao": "R",
    "pgtoBDtAtualizacao": "2025-06-02T21:53:44.000+00:00",
    "pgtoBInHistorico": "S",
    "pgtoUa": "08196",
    "pgtoEstbPjNr": null,
    "pgtoEstbNr": null,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20220531,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": "99999999999999999",
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": 581397968,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "2022-05-30",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20211231,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": 818000,
    "pgtoBIpTerminal": "172.20.138.179",
    "pgtoBNrTerminal": "SUITERFB",
    "pgtoBPfNrAtualiza": 988643357,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 91,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "7012215095467217",
    "pgtoDtLimitePgtoDeb": "2022-05-31",
    "pgtoDtRecepRegEmAg": "2022-05-30T13:41:30",
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": "We9XzmYeqEGvaavO6Dvu1ihQY07edh1cDUh",
    "pgtoInCondSitReg": 1,
    "pgtoUaDtPgto": 819600,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": "2022-05-30T13:41:30",
    "pgtoInOrigemAr": 1,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": 1,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 1,
      "descricao": "GUICHÊ DE CAIXA"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 1,
    "procedencia": {
      "codigo": 7,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-EMISSÃO DE DOCUMENTO"
    },
    "pgtoSearTprCd": 7,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": {
      "codigo": 1,
      "descricao": "DINHEIRO"
    },
    "pgtoTifpCd": 1,
    "receita01": {
      "codigo": 211,
      "descricao": "IRPF - Declaração de Ajuste Anual, Declaração de Saída Definitiva do País e Declaração Final de Espólio",
      "nomeEditado": "IRPF - Declaração de ajuste anual, saída do país e espólio",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 211,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": {
      "codigo": 45,
      "descricao": "PROGRAMA GERADOR DO PGD IRPF"
    },
    "pgtoTsgiCd": 45,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "pgtoTpsiCd": 17,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": {
      "id": 7107,
      "nome": "SÃO PAULO",
      "ufSg": "SP",
      "estado": {
        "id": "SP",
        "nome": "SÃO PAULO",
        "version": null
      },
      "version": null
    },
    "pgtoBCdMunDomContrib": 7107,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      24974.01
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": "D113A1C89F6AFE9F",
    "codigoBarras": "85840000249740103852215107012215095467217637",
    "pessoaFisicaDto": {
      "codigo": 58139796891,
      "nome": "VOR NZIRZ NVRIVOOVH SVRMRMTVI"
    },
    "pessoaJuridicaDto": null,
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": true,
    "documentoNumerado": true,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": true,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "2231587923",
    "pgtoDtArrecadacao": "2013-07-25",
    "pgtoDtRegistro": "2013-07-27T06:11:27.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 8822.71,
    "pgtoBVl1": 8822.71,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 5034,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "3382",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 8822.71,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "17",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2013-07-26T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "01280",
    "pgtoEstbPjNr": 1646611,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20130725,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2013-07-26",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20130630,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "F",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 74,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10100104964172691",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 8109,
      "descricao": "PIS - Faturamento",
      "nomeEditado": "PIS - Faturamento",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 8109,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      0
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 1646611000174,
      "nome": "CONTRIBUINTE  1646611",
      "estbBInAcompEspecial": "N",
      "estbBInAcompDiferen": "N"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "2231588123",
    "pgtoDtArrecadacao": "2013-07-25",
    "pgtoDtRegistro": "2013-07-27T06:11:27.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 19955.64,
    "pgtoBVl1": 19955.64,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 5034,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "3382",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 19955.64,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "17",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2013-07-26T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "01280",
    "pgtoEstbPjNr": 1646611,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20130725,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2013-07-26",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20130630,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "F",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 74,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10100104964172711",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 5856,
      "descricao": "Cofins Não-Cumulativa",
      "nomeEditado": "COFINS não-cumulativa",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 5856,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      0
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 1646611000174,
      "nome": "CONTRIBUINTE  1646611",
      "estbBInAcompEspecial": "N",
      "estbBInAcompDiferen": "N"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "1386067695",
    "pgtoDtArrecadacao": "2024-11-26",
    "pgtoDtRegistro": "2024-11-28T04:54:07.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 15451.23,
    "pgtoBVl1": 15451.23,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 2,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "0002",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "09",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2024-11-27T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "01101",
    "pgtoEstbPjNr": 352294,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20241130,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": "352294000110",
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2024-11-27",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20241101,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "E",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 10,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10100108133000014",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 6092,
      "descricao": "Contribuições Previdenciárias - Recolhimento Exclusivo pela Justiça do Trabalho",
      "nomeEditado": "Contribuição Previdenciária - Recolhimento Justiça Trabalho",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 6092,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 9,
      "descricao": "OUTROS INTERESSES"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 352294000110,
      "nome": "CONTRIBUINTE  352294",
      "estbBInAcompEspecial": "S",
      "estbBInAcompDiferen": "S"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "1126508395",
    "pgtoDtArrecadacao": "2024-05-07",
    "pgtoDtRegistro": "2024-05-09T04:48:04.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 1152.48,
    "pgtoBVl1": 1152.48,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 2,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "0002",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "09",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2024-05-08T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "01101",
    "pgtoEstbPjNr": 352294,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20240507,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2024-05-08",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20240531,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "E",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 10,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10100107940000024",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 6092,
      "descricao": "Contribuições Previdenciárias - Recolhimento Exclusivo pela Justiça do Trabalho",
      "nomeEditado": "Contribuição Previdenciária - Recolhimento Justiça Trabalho",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 6092,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 9,
      "descricao": "OUTROS INTERESSES"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 352294000110,
      "nome": "CONTRIBUINTE  352294",
      "estbBInAcompEspecial": "S",
      "estbBInAcompDiferen": "S"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "1159297565",
    "pgtoDtArrecadacao": "2024-06-03",
    "pgtoDtRegistro": "2024-06-05T06:43:15.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 1899.97,
    "pgtoBVl1": 1555.76,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 2,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "0002",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "09",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2024-06-04T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "02201",
    "pgtoEstbPjNr": 4407029,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20240630,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": "602222017",
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2024-06-04",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20240601,
    "pgtoMndpCd": null,
    "pgtoBVl2": 344.21,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "E",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 43,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10100107964000022",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 6092,
      "descricao": "Contribuições Previdenciárias - Recolhimento Exclusivo pela Justiça do Trabalho",
      "nomeEditado": "Contribuição Previdenciária - Recolhimento Justiça Trabalho",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 6092,
    "receita02": {
      "codigo": 6092,
      "descricao": "Contribuições Previdenciárias - Recolhimento Exclusivo pela Justiça do Trabalho",
      "nomeEditado": "Contribuição Previdenciária - Recolhimento Justiça Trabalho",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd2": 6092,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 9,
      "descricao": "OUTROS INTERESSES"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 4407029000143,
      "nome": "CONTRIBUINTE  4407029",
      "estbBInAcompEspecial": "N",
      "estbBInAcompDiferen": "N"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "825101785",
    "pgtoDtArrecadacao": "2023-09-04",
    "pgtoDtRegistro": "2023-09-07T04:47:08.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 447.04,
    "pgtoBVl1": 423.35,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 2,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "0002",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "01",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2023-09-05T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "02181",
    "pgtoEstbPjNr": null,
    "pgtoEstbNr": null,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20230831,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": 413156182,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2023-09-05",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20221231,
    "pgtoMndpCd": null,
    "pgtoBVl2": 5.58,
    "pgtoBVl3": 18.11,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "X",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 49,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10100107662000012",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 1,
      "descricao": "GUICHÊ DE CAIXA"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 1,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 211,
      "descricao": "IRPF - Declaração de Ajuste Anual, Declaração de Saída Definitiva do País e Declaração Final de Espólio",
      "nomeEditado": "IRPF - Declaração de ajuste anual, saída do país e espólio",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 211,
    "receita02": {
      "codigo": 3244,
      "descricao": "Multa - IRPF",
      "nomeEditado": "Multa - IRPF",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd2": 3244,
    "receita03": {
      "codigo": 641,
      "descricao": "Juros IRPF",
      "nomeEditado": "Juros - IRPF",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd3": 641,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 1,
      "descricao": "CONTACORPF"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": null,
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "1020968225",
    "pgtoDtArrecadacao": "2024-01-03",
    "pgtoDtRegistro": "2024-01-09T04:44:28.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 460.26,
    "pgtoBVl1": 423.35,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 2,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "0002",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 0,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "01",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2024-01-04T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "02181",
    "pgtoEstbPjNr": null,
    "pgtoEstbNr": null,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20240103,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": 413156182,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2024-01-04",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20221231,
    "pgtoMndpCd": null,
    "pgtoBVl2": 2.79,
    "pgtoBVl3": 34.12,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "X",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 49,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10100107805000007",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 1,
      "descricao": "GUICHÊ DE CAIXA"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 1,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 211,
      "descricao": "IRPF - Declaração de Ajuste Anual, Declaração de Saída Definitiva do País e Declaração Final de Espólio",
      "nomeEditado": "IRPF - Declaração de ajuste anual, saída do país e espólio",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 211,
    "receita02": {
      "codigo": 3244,
      "descricao": "Multa - IRPF",
      "nomeEditado": "Multa - IRPF",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd2": 3244,
    "receita03": {
      "codigo": 641,
      "descricao": "Juros IRPF",
      "nomeEditado": "Juros - IRPF",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd3": 641,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 1,
      "descricao": "CONTACORPF"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      1
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": null,
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "836904414",
    "pgtoDtArrecadacao": "2017-08-04",
    "pgtoDtRegistro": "2017-08-09T07:57:54.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 3972.11,
    "pgtoBVl1": 3972.11,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 2,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "0002",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 3972.11,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "17",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2017-08-07T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "01280",
    "pgtoEstbPjNr": 0,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20170815,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": "5268176234",
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2017-08-07",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20170810,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "E",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 91,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10100106065000003",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 1723,
      "descricao": "CPSS - Servidor Civil Ativo - Precatório Judicial e Requisição de Pequeno Valor",
      "nomeEditado": "CPSS - Servidor Civil Ativo - Precatório/Requisiç Peq Valor",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 1723,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      0
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 191,
      "nome": "CONTRIBUINTE  0",
      "estbBInAcompEspecial": "S",
      "estbBInAcompDiferen": "S"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": "N",
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "838566414",
    "pgtoDtArrecadacao": "2017-08-07",
    "pgtoDtRegistro": "2017-08-10T06:40:23.000+00:00",
    "pgtoInTp": "4",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": null,
    "pgtoBVlAlocadoRl": null,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 4401.7,
    "pgtoBVl1": 4401.7,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 2,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "0002",
    "pgtoInDesmembrado": "NA",
    "pgtoBVlRlocal": 4401.7,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "17",
    "pgtoBInPassivo": "S",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2017-08-08T03:00:00.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "01280",
    "pgtoEstbPjNr": 0,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20170815,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": 0,
    "pgtoBDtRecepcao": "2017-08-08",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20170810,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": null,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": "E",
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 91,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "10100106066000007",
    "pgtoDtLimitePgtoDeb": null,
    "pgtoDtRecepRegEmAg": null,
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": null,
    "pgtoUaDtPgto": null,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": null,
    "pgtoInOrigemAr": null,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": null,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 1,
      "descricao": "PRESTADOR DE SERVIÇO"
    },
    "pgtoSearTprCd": 1,
    "segmentoProcedencia": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTspCd": 1,
    "indicadorAutomacao": {
      "codigo": 1,
      "descricao": "NENHUM"
    },
    "pgtoSearTaudCd": 1,
    "indicadorFormaPagamento": null,
    "pgtoTifpCd": null,
    "receita01": {
      "codigo": 1723,
      "descricao": "CPSS - Servidor Civil Ativo - Precatório Judicial e Requisição de Pequeno Valor",
      "nomeEditado": "CPSS - Servidor Civil Ativo - Precatório/Requisiç Peq Valor",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 1723,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": null,
    "pgtoTsgiCd": null,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "pgtoTpsiCd": null,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": null,
    "pgtoBCdMunDomContrib": null,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      0
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": null,
    "codigoBarras": null,
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 191,
      "nome": "CONTRIBUINTE  0",
      "estbBInAcompEspecial": "S",
      "estbBInAcompDiferen": "S"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": "N",
    "pago": false,
    "documentoNumerado": false,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": false,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "7162000262380006",
    "pgtoDtArrecadacao": "2020-06-29",
    "pgtoDtRegistro": "2020-06-29T17:25:59.000+00:00",
    "pgtoInTp": "0",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": 0,
    "pgtoBVlAlocadoRl": 0,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 75240.23,
    "pgtoBVl1": 75240.23,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 2,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "0002",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 75240.23,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "99",
    "pgtoBInPassivo": "N",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2020-06-29T17:25:59.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "10103",
    "pgtoEstbPjNr": 89800502,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20200320,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "2020-06-29",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20200201,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 0,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "7162000262380006",
    "pgtoDtLimitePgtoDeb": "2020-03-20",
    "pgtoDtRecepRegEmAg": "2020-01-02T13:17:51",
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": 1,
    "pgtoUaDtPgto": 1010300,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": "2020-01-02T13:17:51",
    "pgtoInOrigemAr": 1,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": 1,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 1,
      "descricao": "GUICHÊ DE CAIXA"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 1,
    "procedencia": {
      "codigo": 7,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-EMISSÃO DE DOCUMENTO"
    },
    "pgtoSearTprCd": 7,
    "segmentoProcedencia": {
      "codigo": 16,
      "descricao": "PUC - ESOCIAL"
    },
    "pgtoSearTspCd": 16,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": {
      "codigo": 1,
      "descricao": "DINHEIRO"
    },
    "pgtoTifpCd": 1,
    "receita01": {
      "codigo": 1410,
      "descricao": "DCTF-Web - Pagamento Unificado",
      "nomeEditado": "DCTF-Web - Pagamento Unificado",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 1410,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": {
      "codigo": 12,
      "descricao": "Programa Gerador do DCTFWeb"
    },
    "pgtoTsgiCd": 12,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "pgtoTpsiCd": 17,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": {
      "id": 8841,
      "nome": "SANTA MARIA",
      "ufSg": "RS",
      "estado": {
        "id": "RS",
        "nome": "RIO GRANDE DO SUL",
        "version": null
      },
      "version": null
    },
    "pgtoBCdMunDomContrib": 8841,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      4249.01
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": "13D40E19287CJA09",
    "codigoBarras": "85870000752402303852008007162000262380006036",
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 89800502000100,
      "nome": "CONTRIBUINTE  89800502",
      "estbBInAcompEspecial": "N",
      "estbBInAcompDiferen": "S"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": "N",
    "pago": true,
    "documentoNumerado": true,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": true,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "7162000262380014",
    "pgtoDtArrecadacao": "2020-06-29",
    "pgtoDtRegistro": "2020-06-29T17:25:59.000+00:00",
    "pgtoInTp": "0",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": 0,
    "pgtoBVlAlocadoRl": 0,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 75240.23,
    "pgtoBVl1": 75240.23,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 2,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "0002",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 75240.23,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "99",
    "pgtoBInPassivo": "N",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2020-06-29T17:25:59.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "10103",
    "pgtoEstbPjNr": 89800502,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20200320,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": null,
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "2020-06-29",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20200201,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 0,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "7162000262380014",
    "pgtoDtLimitePgtoDeb": "2020-03-20",
    "pgtoDtRecepRegEmAg": "2020-01-02T13:18:00",
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": 1,
    "pgtoUaDtPgto": 1010300,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": "2020-01-02T13:18:00",
    "pgtoInOrigemAr": 1,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": 1,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 1,
      "descricao": "GUICHÊ DE CAIXA"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 1,
    "procedencia": {
      "codigo": 7,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-EMISSÃO DE DOCUMENTO"
    },
    "pgtoSearTprCd": 7,
    "segmentoProcedencia": {
      "codigo": 16,
      "descricao": "PUC - ESOCIAL"
    },
    "pgtoSearTspCd": 16,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": {
      "codigo": 1,
      "descricao": "DINHEIRO"
    },
    "pgtoTifpCd": 1,
    "receita01": {
      "codigo": 1410,
      "descricao": "DCTF-Web - Pagamento Unificado",
      "nomeEditado": "DCTF-Web - Pagamento Unificado",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 1410,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": {
      "codigo": 12,
      "descricao": "Programa Gerador do DCTFWeb"
    },
    "pgtoTsgiCd": 12,
    "sistemaInteresse": {
      "codigo": 17,
      "descricao": "PJ REDE LOCAL"
    },
    "pgtoTpsiCd": 17,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": {
      "id": 8841,
      "nome": "SANTA MARIA",
      "ufSg": "RS",
      "estado": {
        "id": "RS",
        "nome": "RIO GRANDE DO SUL",
        "version": null
      },
      "version": null
    },
    "pgtoBCdMunDomContrib": 8841,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      55155.67
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": "A0BEA5A86563JA09",
    "codigoBarras": "85870000752402303852008007162000262380014136",
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 89800502000100,
      "nome": "CONTRIBUINTE  89800502",
      "estbBInAcompEspecial": "N",
      "estbBInAcompDiferen": "S"
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": "N",
    "pago": true,
    "documentoNumerado": true,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": true,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "7171808685799073",
    "pgtoDtArrecadacao": "2018-03-28",
    "pgtoDtRegistro": "2025-06-06T18:12:28.000+00:00",
    "pgtoInTp": "0",
    "situacao": {
      "codigo": 7,
      "descricao": "BLOQUEADO PARCIAL"
    },
    "pgtoSituCd": 7,
    "pgtoBVlCompensacao": 0,
    "pgtoBVlAlocadoRl": 0,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 205.24,
    "pgtoBVl1": 130.3,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 72,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "7815",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 205.24,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "99",
    "pgtoBInPassivo": "N",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2025-06-06T18:12:28.000+00:00",
    "pgtoBInHistorico": "S",
    "pgtoUa": "07102",
    "pgtoEstbPjNr": null,
    "pgtoEstbNr": null,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20180329,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": "1852236",
    "pgtoProcNr": "10880412494201217",
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": 14070667,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "2018-03-29",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20180329,
    "pgtoMndpCd": null,
    "pgtoBVl2": 48.86,
    "pgtoBVl3": 26.08,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": 818000,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": "SUITERFB",
    "pgtoBPfNrAtualiza": 988643357,
    "pgtoBVlRestituicao": 11.01,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 0,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 49,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "7171808685799073",
    "pgtoDtLimitePgtoDeb": "2018-03-29",
    "pgtoDtRecepRegEmAg": "2018-03-27T11:29:06",
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": 1,
    "pgtoUaDtPgto": 710200,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": "2018-03-27T11:29:06",
    "pgtoInOrigemAr": 1,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": 1,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 1,
      "descricao": "GUICHÊ DE CAIXA"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 1,
    "procedencia": {
      "codigo": 7,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-EMISSÃO DE DOCUMENTO"
    },
    "pgtoSearTprCd": 7,
    "segmentoProcedencia": {
      "codigo": 17,
      "descricao": "PGFN"
    },
    "pgtoSearTspCd": 17,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": {
      "codigo": 1,
      "descricao": "DINHEIRO"
    },
    "pgtoTifpCd": 1,
    "receita01": {
      "codigo": 1734,
      "descricao": "R D Ativa - Parcelamento",
      "nomeEditado": "R D Ativa - Parcelamento",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 1734,
    "receita02": {
      "codigo": 1735,
      "descricao": "Multa - Parcelamento -  Dívida Ativa",
      "nomeEditado": "Multa - Parcelamento -  Dívida Ativa",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd2": 1735,
    "receita03": {
      "codigo": 1736,
      "descricao": "Juros - Parcelamento - Dívida Ativa",
      "nomeEditado": "Juros - Parcelamento - Dívida Ativa",
      "tipo": "E",
      "dataExtincao": null
    },
    "pgtoBRecCd3": 1736,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": {
      "codigo": 14,
      "descricao": "PROGRAMA GERADOR DO SISPAR - PGFN"
    },
    "pgtoTsgiCd": 14,
    "sistemaInteresse": {
      "codigo": 38,
      "descricao": "SISPAR"
    },
    "pgtoTpsiCd": 38,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": {
      "id": 5865,
      "nome": "NITERÓI",
      "ufSg": "RJ",
      "estado": {
        "id": "RJ",
        "nome": "RIO DE JANEIRO",
        "version": null
      },
      "version": null
    },
    "pgtoBCdMunDomContrib": 5865,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      194.23
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": "CC715D374862B3FB",
    "codigoBarras": "85820000002052403851808807171808685799073046",
    "pessoaFisicaDto": {
      "codigo": 1407066749,
      "nome": "QFEVMXRL UZFHGL WV XZNKLH"
    },
    "pessoaJuridicaDto": null,
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": true,
    "documentoNumerado": true,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": true,
    "dje": false,
    "das": false
  },
  {
    "pgtoNr": "7102500318642102",
    "pgtoDtArrecadacao": "2025-01-06",
    "pgtoDtRegistro": "2025-01-06T17:36:54.000+00:00",
    "pgtoInTp": "0",
    "situacao": {
      "codigo": 1,
      "descricao": "ORIGINAL"
    },
    "pgtoSituCd": 1,
    "pgtoBVlCompensacao": 0,
    "pgtoBVlAlocadoRl": 0,
    "pgtoInContribNIdent": "N",
    "pgtoInUtilCobranca": "N",
    "pgtoVlTotal": 12602.59,
    "pgtoBVl1": 12602.59,
    "pgtoInImpedeAloc": "N",
    "pgtoInOrigem": "N",
    "pgtoAgenAgtaCd": 1,
    "pgtoAgenCd": 2,
    "codigoBancoCPS": "001",
    "codigoAgenciaCPS": "0002",
    "pgtoInDesmembrado": null,
    "pgtoBVlRlocal": 12602.59,
    "pgtoBVlGporte": 0,
    "valorCancelado": null,
    "pgtoBInInteresse": "99",
    "pgtoBInPassivo": "N",
    "pgtoBInAtualizacao": "N",
    "pgtoBDtAtualizacao": "2025-01-06T17:36:54.000+00:00",
    "pgtoBInHistorico": "N",
    "pgtoUa": "08166",
    "pgtoEstbPjNr": 1235622,
    "pgtoEstbNr": 1,
    "pgtoOepgCd": null,
    "origemErro": null,
    "pgtoDtVencimento": 20250203,
    "pgtoNrPeriodoApur": null,
    "pgtoNrProcesso": null,
    "pgtoNrReferencia": "60010141579",
    "pgtoProcNr": null,
    "pgtoNrParcela": null,
    "pgtoReleNrSq": null,
    "pgtoPfNr": null,
    "pgtoBNrBdaSq": null,
    "pgtoRpapNrBda": null,
    "pgtoBDtRecepcao": "2025-01-06",
    "pgtoAlspCd": null,
    "pgtoDtEncerraPerApu": 20250103,
    "pgtoMndpCd": null,
    "pgtoBVl2": null,
    "pgtoBVl3": null,
    "pgtoBVl4": null,
    "pgtoBVl5": null,
    "pgtoBUaCdAtualiza": null,
    "pgtoBIpTerminal": null,
    "pgtoBNrTerminal": null,
    "pgtoBPfNrAtualiza": null,
    "pgtoBVlRestituicao": 0,
    "pgtoNrContribNident": null,
    "pgtoInAutorizaDebCc": null,
    "pgtoInMeioColeta": null,
    "pgtoNrProtocolDebCc": null,
    "pgtoNrIdDepositoCef": null,
    "pgtoBVlSaldoPrincipal": 12602.59,
    "pgtoBVlSaldoMulta": 0,
    "pgtoBVlSaldoJuros": 0,
    "pgtoBInDelecaoLogica": "N",
    "pgtoBInRecInval": null,
    "pgtoNrDvContrib": 61,
    "pgtoBDtRegistroGporte": null,
    "pgtoNrIdAr": "7102500318642102",
    "pgtoDtLimitePgtoDeb": "2025-02-03",
    "pgtoDtRecepRegEmAg": "2025-01-03T14:30:22",
    "pgtoInMeioRecepInf": null,
    "pgtoNrCtrlRecepInf": null,
    "pgtoInCondSitReg": 1,
    "pgtoUaDtPgto": 816600,
    "pgtoUaClassCd": null,
    "pgtoDtGerRegSistOrig": "2025-01-03T14:30:22",
    "pgtoInOrigemAr": 1,
    "pgtoBVlDjeSunl": 0,
    "pgtoBVlDjeSdnl": 0,
    "pgtoBVlDjeSutd": 0,
    "pgtoBVlDjeSdtd": 0,
    "pgtoBVlDjeVtdc": 0,
    "pgtoPgtoNrIdAr": null,
    "pgtoNitNi": null,
    "pgtoNrInscrDau": null,
    "pgtoNrCno": null,
    "pgtoNrNit": null,
    "pgtoNrNirf": null,
    "pgtoCnpjPrestador": null,
    "pgtoCpfSegurado": null,
    "pgtoEdbaNrSq": null,
    "pgtoTqrpCd": 1,
    "pgtoMcanCd": null,
    "modalidadeArrecadacao": {
      "codigo": 3,
      "descricao": "AUTO-ATENDIMENTO"
    },
    "pgtoPcRecBrut": null,
    "pgtoVlRecBrutAcum": null,
    "pgtoSearTmarCd": 3,
    "procedencia": {
      "codigo": 7,
      "descricao": "AMBIENTE DE PAGAMENTO RFB-EMISSÃO DE DOCUMENTO"
    },
    "pgtoSearTprCd": 7,
    "segmentoProcedencia": {
      "codigo": 10,
      "descricao": "SISTEMA INTEGRADO DE ADMINISTRAÇÃO PATRIMONIAL ON-LINE"
    },
    "pgtoSearTspCd": 10,
    "indicadorAutomacao": {
      "codigo": 2,
      "descricao": "CÓDIGO DE BARRAS"
    },
    "pgtoSearTaudCd": 2,
    "indicadorFormaPagamento": {
      "codigo": 1,
      "descricao": "DINHEIRO"
    },
    "pgtoTifpCd": 1,
    "receita01": {
      "codigo": 2081,
      "descricao": "Laudêmios",
      "nomeEditado": "Laudêmios",
      "tipo": "P",
      "dataExtincao": null
    },
    "pgtoBRecCd1": 2081,
    "receita02": null,
    "pgtoBRecCd2": null,
    "receita03": null,
    "pgtoBRecCd3": null,
    "receita04": null,
    "pgtoBRecCd4": null,
    "receita05": null,
    "pgtoBRecCd5": null,
    "pgtoBRecDt1": null,
    "pgtoBRecDt2": null,
    "pgtoBRecDt3": null,
    "pgtoBRecDt4": null,
    "pgtoBRecDt5": null,
    "pgtoBOepgDt": null,
    "pgtoBSituDt": null,
    "pgtoBAgenDt": null,
    "pgtoBMcanDt": null,
    "pgtoBMndpDt": null,
    "pgtoBAlspDt": null,
    "tipoDocumento": {
      "codigo": 4,
      "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
      "nomeAbreviado": "DARF"
    },
    "pgtoSearTdaCd": 4,
    "natureza": {
      "codigo": 1,
      "descricao": "PAGAMENTO/DEPÓSITO"
    },
    "pgtoTnrCd": 1,
    "sistemaGerador": {
      "codigo": 3,
      "descricao": "SPU"
    },
    "pgtoTsgiCd": 3,
    "sistemaInteresse": {
      "codigo": 31,
      "descricao": "SPU"
    },
    "pgtoTpsiCd": 31,
    "municipioClassificacao": null,
    "pgtoMunicClassCd": null,
    "municipioDomicilioContribuinte": {
      "id": 7107,
      "nome": "SÃO PAULO",
      "ufSg": "SP",
      "estado": {
        "id": "SP",
        "nome": "SÃO PAULO",
        "version": null
      },
      "version": null
    },
    "pgtoBCdMunDomContrib": 7107,
    "pgtoDovrNrSq": null,
    "alterouBase2": null,
    "nSaldoDisponivel": [
      0,
      12602.59
    ],
    "nValorDevolvido": 0,
    "nValorTransformado": 0,
    "nValorReservadoApuracaoRTC": 0,
    "nValorFGTSEConsignado": 0,
    "darcNrAutenticPgto": "58F9D065E1A6FFB3",
    "codigoBarras": "85830000126025903852503407102500318642102477",
    "pessoaFisicaDto": null,
    "pessoaJuridicaDto": {
      "codigo": 1235622000161,
      "nome": "-",
      "estbBInAcompEspecial": null,
      "estbBInAcompDiferen": null
    },
    "agendadoPara": null,
    "nrTransformacaoNo": null,
    "mensagemVinculacao": null,
    "pgtoInDara": null,
    "pago": true,
    "documentoNumerado": true,
    "canceladoTransformacao": false,
    "vinculado": false,
    "agendado": false,
    "canceladoParcial": false,
    "cancelado": false,
    "darfNumerado": true,
    "dje": false,
    "das": false
  }
];